import React, { useRef, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
    Button,
    colors,
    Container,
    CssBaseline,
    Hidden,
    makeStyles,
    Paper,
    Typography,
} from "@material-ui/core";
import { useTranslation } from "react-i18next";
import {
    useStylesLbl,
} from '../../../../St/Reports/UseStyle';
import {
    useStylesTF,
} from "../../../../St/comps/UseStyle";
import { sto } from "../../../../Context/InshData";
import i18next from "i18next";
import RestInfoDialog from "../models/RestInfo/RestInfoDialog";
import CloudUpload from "@material-ui/icons/CloudUpload";
import { menuBottonsFile, menuBottonsMultiFile } from "../components/SearchItemsFunction";
const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    userTitle: {
        textAlign: "right",
        fontSize: 16,
        width: "100%",
        fontWeight: "bold",
        paddingTop: "0.6rem"

    },
    headerTitle: {
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        fontWeight: "bold"
    },
    headerTitle2: {
        backgroundColor: colors.green[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    headerTitleP: {
        backgroundColor: colors.blue[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
        direction: "rtl"
    },
    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.blue[50],
        borderColor: colors.blue[300],
    },
}));

export default function InvoiceFooter(props) {
    const {
        isPurches,
        setting,
        idata,
        valueType,
        uiElement,
        changIdata,
        isStock,
        permistionInv,
        changinvDisc,
        invDisc,
        changClick,
        payment,
        changPayment,
        sums,
        currentUserName,
        isHedden,
        permiCuCo,
        or,
        setFile,
        setFiles,
        handleDownload,
    } = props;


    const total_before_disc = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.amountBefordisc);

    const total_purchase = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.tot_purch);


    const total_sale = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.tot_sale);

    const total_after_disc = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.amountAfterDisc);

    const vatTotal = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.amountOfVat);

    const total_net = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(idata.netAmount);



    const { t } = useTranslation(["forms"]);
    const claslbls = useStylesLbl();
    const clasTF = useStylesTF();
    const classes = useStyles();
    const [infoData, setInfoData] = useState({ open: false });

    const fileInputRef = useRef(null);

    const openFileDialog = () => {
        fileInputRef.current.click();
    };
    const [menPostion, setMenuPostion] = useState(null);

    const handleFileSelect = (event) => {
        const selected = event.target.files[0];
        setFile(selected);
    };
    const handleMultiFilesSelect = (event) => {
        const selected =Array.from( event.target.files);
        setFiles(selected);
    };

    const handleClickInLine = (e) => {
        e.preventDefault();
        setMenuPostion({
            x: e.pageX,
            y: e.pageY,
        });
    };

    const handleClickOutLine = () => {
        setMenuPostion(null);
    };

    return (
        <div className={classes.root}
        // onClick={(e) => handleClickOutLine(e)}
        >

            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <CssBaseline />
                <Container
                    component={Paper}
                    maxWidth={false}
                    style={{
                        padding: "10px",
                        paddingBottom: "0px",
                        borderBottomColor: isPurches ? "#008080" : isStock ? "#3f51b5" : colors.green[300],
                        borderBottomWidth: "1px",
                        borderBottomStyle: "solid",
                    }}
                >
                    <React.Fragment>
                        <Grid container style={{ padding: 5 }} spacing={1}  >


                            <Grid item lg={3} md={3} sm={4} xs={8} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    id="refno"
                                    label={t("note")}
                                    multiline
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrSale }}
                                    inputProps={{ borderColor: "black", className: claslbls.clrBlackLblS }}
                                    type="text"
                                    name="notes"
                                    style={{ maxHeight: "3rem" }}
                                    value={idata.notes}
                                    onChange={changIdata("notes")}
                                />
                            </Grid>
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="stay"
                                    label={t("remaining")}
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{
                                        className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS :
                                            claslbls.clrBlackLblSal, readOnly: true
                                    }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="number"
                                    name="remaining"
                                    value={payment.stay}
                                    placeholder="0"
                                    onChange={changIdata("stay")}
                                /></Grid>
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="paidup"
                                    label={t("paid")}
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: valueType.id == 1 ? false : true }}
                                    type="text"
                                    name="paidup"
                                    value={payment.paidup}
                                    placeholder="0"
                                    onChange={changPayment("paidup")
                                    }
                                /></Grid>
                            <Grid item lg={1} md={1} sm={2} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small" id="val1"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="number"
                                    label={t("total-quantity")}
                                    name="val1"
                                    value={parseFloat(sums.val1).toFixed(2)}
                                /></Grid>
                            {setting.PrTy_InPr == "02" || setting.PrTy_InPr == "12" ? (

                                <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small" id="tot_sale"
                                        className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                        inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                        type="text"
                                        label={setting.priceTotNM}
                                        name="tot_sale"
                                        value={total_sale}
                                    // placeholder="0.00"
                                    /></Grid>) : (
                                <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                        InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                        inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                        type="text"
                                        id="tot_purch"
                                        label={setting.priceTotNM}
                                        name="tot_purch"
                                        value={total_purchase}
                                    // placeholder="0.00"
                                    /></Grid>
                            )}
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="text"
                                    // id="amountWithVat"
                                    // name="amountWithVat"
                                    id="amountBefordisc"
                                    name="amountBefordisc"
                                    // label={t("total-after-descount")}
                                    // value={idata.amountWithVat}
                                    label={t("total_before_discount")}
                                    value={total_before_disc}
                                // placeholder="0.00"
                                /></Grid>


                            <Hidden only={["xs"]}>
                                <Grid container item lg={2} md={or.postput == "toPut"?4:2} sm={4} xs={6} >
                                    <Grid item lg={6} md={8} sm={12} xs={12}  >
                                        <div style={{whiteSpace:"pre-line", fontWeight: "bold", color:"#0d47a1" }}>
                                            {`${permiCuCo?.CWVtxt}\n${t("user") + ":   "}${sto.usernames}`}
                                        </div>
                                    </Grid>
                                    <Grid container item lg={6} md={4} sm={12} xs={12} spacing={1}>
                                        <Grid item lg={6} md={6} sm={6} xs={6}  >
                                            {or.postput == "toPut" && setting.PrTy_InPr !== "03"
                                                && setting.PrTy_InPr !== "04" && setting.PrTy_InPr !== "33" && (
                                                    <Hidden only={"xs"}>
                                                        <Button
                                                            fullWidth
                                                            autoFocus
                                                            variant="contained"
                                                            onClick={(e) => {
                                                                setInfoData({ open: true, })
                                                            }}
                                                            style={{
                                                                background: colors.grey[300],
                                                                ...{
                                                                    paddingLeft: 0,
                                                                    paddingRight: 0,
                                                                },
                                                            }}

                                                        >
                                                            {t("journal-entry") + "  "}
                                                        </Button>
                                                    </Hidden>
                                                )}
                                        </Grid>
                                        {permistionInv?.ARCHIVE === true && (
                                            <Grid item lg={6} md={6} sm={6} xs={6} >
                                                {or.postput == "toPost" ?
                                                    (
                                                        <>
                                                            <Hidden smDown>
                                                                <Button
                                                                    fullWidth
                                                                    autoFocus
                                                                    variant="contained"
                                                                    onClick={(e) => {
                                                                        openFileDialog();
                                                                    }}
                                                                    style={{
                                                                        background: colors.grey[300],
                                                                        ...{
                                                                            paddingLeft: 0,
                                                                            paddingRight: 0,
                                                                        },
                                                                    }}
                                                                    startIcon={<CloudUpload />}
                                                                >
                                                                    {"  "}
                                                                </Button>
                                                            </Hidden>
                                                            <input
                                                                type="file"
                                                                ref={fileInputRef}
                                                                multiple
                                                                style={{ display: "none" }}
                                                                onChange={handleMultiFilesSelect} />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <Hidden smDown>

                                                                <Button
                                                                    fullWidth
                                                                    autoFocus
                                                                    variant="contained"
                                                                    color="#000"
                                                                    onClick={(e) => {
                                                                        handleClickInLine(e);
                                                                    }}
                                                                    style={{
                                                                        background: colors.grey[300],
                                                                        ...{
                                                                            paddingLeft: 0,
                                                                            paddingRight: 0,
                                                                        },
                                                                    }}
                                                                    startIcon={<CloudUpload />}
                                                                >
                                                                    {"  "}
                                                                </Button>
                                                            </Hidden>

                                                        </>
                                                    )}


                                            </Grid>
                                        )}

                                    </Grid>

                                </Grid>
                            </Hidden>


                            {menPostion && menuBottonsMultiFile (handleClickOutLine,openFileDialog,handleDownload,menPostion,fileInputRef,handleMultiFilesSelect)}

                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="text"
                                    id="amountAfterDisc"
                                    // label={t("total-before-tax")}
                                    label={t("total_before_vat")}
                                    name="amountAfterDisc"
                                    value={total_after_disc}
                                // placeholder="0.00"
                                /></Grid>
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="text"
                                    id="amountOfVat"
                                    label={t("total-value-add")}
                                    name="amountOfVat"
                                    // value={parseFloat(idata.amountOfVat).toFixed(2)}
                                    value={vatTotal}
                                // placeholder="0"
                                /></Grid>

                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: true }}
                                    type="text"
                                    id="netAmountSub"
                                    label={t("net")}
                                    name="netAmountSub"
                                    style={{ backgroundColor: isPurches ? colors.blue[50] : isStock ? colors.blue[50] : colors.green[50] }}
                                    // value={parseFloat(idata.netAmount).toFixed(2)}
                                    value={total_net}
                                // placeholder="0.00"
                                /></Grid>
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>
                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: uiElement.minus }}
                                    id="minus"
                                    label={t("discount-amount")}
                                    disabled={
                                        isHedden ? true :
                                            (permistionInv.APDC === 2 || permistionInv.APDC === 3) && permistionInv.DSOB == 1
                                                ? false
                                                : true
                                    }
                                    type="number"
                                    onClick={() => changClick("minus", false)}
                                    name="minus"
                                    value={invDisc.minus}
                                    placeholder="0"
                                    onChange={changinvDisc("minus")}
                                /></Grid>
                            <Grid item lg={2} md={2} sm={3} xs={4} style={{ paddingBottom: "0.5rem" }}>

                                <TextField fullWidth variant="outlined" size="small"
                                    className={isPurches ? clasTF.rootPurch : isStock ? clasTF.rootPurch : clasTF.rootSale}
                                    InputLabelProps={{ className: isPurches ? claslbls.clrBlackLblS : isStock ? claslbls.clrBlackLblS : claslbls.clrBlackLblSal }}
                                    inputProps={{ className: claslbls.clrBlackLblS, readOnly: uiElement.rate }}
                                    id="rate"
                                    label={t("discount")}
                                    disabled={
                                        isHedden ? true :
                                            (permistionInv.APDC === 1 || permistionInv.APDC === 3) && permistionInv.DSOB == 1
                                                ? false
                                                : true
                                    }
                                    type="number"
                                    onClick={() => changClick("rate", false)}
                                    name="rate"
                                    value={invDisc.rate}
                                    placeholder="0"
                                    onChange={changinvDisc("rate")}
                                />


                            </Grid>
                            <Hidden only={"xs"}>
                                <Grid item lg={2} md={2} sm={2} xs={3} style={{ paddingBottom: "0.5rem" }}></Grid>
                            </Hidden>
                        </Grid>
                    </React.Fragment>
                </Container>
                {or.postput == "toPut" && setting.PrTy_InPr !== "03" && setting.PrTy_InPr !== "04"
                    && setting.PrTy_InPr !== "33" && (
                        <RestInfoDialog
                            infoData={infoData}
                            setInfoData={setInfoData}
                            res_id={0}
                            branch={0}
                            fromInv={1}
                            proc_id={idata?.proc_id}
                        />
                    )}


            </Typography>
        </div>
    );
}
